import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { appRoutesObj } from "src/app.paths";

function SchoolInfoHeaderComponent() {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();

  return (
    <div
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
      className="flex flex-col justify-center px-4 w-full mobile:w-full h-[126px] mobile:h-[94px] bg-white rounded-2xl drop-shadow-[0_0px_10px_rgba(0,0,0,0.05)] mt-[142px] mobile:mt-0"
    >
      <div className="flex flex-row justify-between mobile:h-[62px] mobile:p-1">
        <div className="flex flex-row gap-3 mobile:gap-2 items-center">
          <img
            alt=""
            src="/assets/images/school1main.jpeg"
            className="rounded-full w-[88px] h-[85px] mobile:w-[64px] mobile:h-[62px]"
          />
          <div className="h-[68px] font-ar">
            <p className="mb-2 mt-2 text-zinc-500 mobile:text-lg text-2xl font-medium">
              مدارس النجاح
            </p>
            <p className="text-base text-zinc-500 font-light mobile:text-base">
              {t("app.shared.saudiArabia")}
            </p>
          </div>
        </div>

        <div className="flex items-center">
          <button
            className="flex items-center justify-center w-[122px] h-[43px] bg-mint-500 text-white rounded-xl font-ar font-medium text-lg text-center cursor-pointer"
            onClick={() => {
              navigate(appRoutesObj.getNewSchoolProfilePage());
            }}
          >
            {t("app.shared.modifyData")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SchoolInfoHeaderComponent;
